<template>
  <a
    class="o-gotoTop"
    ref="vGotop"
    v-show="showBackToTopStatus"
    :style="goTopStyle"
    @click="goToTop"
  >
    <img :src="`${$publicPath}${imgUrl}`" :style="getTopImageStyle" />
  </a>
</template>
<script>
export default {
  name: "scroll-go-top",
  props: {
    imgUrl: {
      type: String,
      default: "assets/images/go-top.svg"
    },
    animationTime: {
      type: Number,
      default: 300
    },
    background: {
      type: String,
      default: "#FFFFFF"
    },
    right: {
      // 距離右邊距離
      type: String,
      default: "30px"
    },
    bottom: {
      // 距離底部距離
      type: String,
      default: "6.5%"
    },
    width: {
      type: String,
      default: "50px"
    },
    height: {
      type: String,
      default: "50px"
    }
  },
  data() {
    return {
      showBackToTopStatus: true,
      overLimitOffset: false
    };
  },
  watch: {
    showBackToTop(val) {
      this.showBackToTopStatus = this.showBackToTop;
    }
  },
  computed: {
    goTopStyle: function() {
      return {
        right: this.right,
        bottom: this.bottom,
        width: this.width,
        height: this.height,
        background: this.background
      };
    },
    getTopImageStyle: function() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  mounted() {
    window.addEventListener("scroll", this.catchScroll);
  },
  methods: {
    setShowBackToTop(value) {
      this.showBackToTop = value;
    },
    catchScroll() {
      if (!this.overLimitOffset && window.pageYOffset >= 200) {
        this.overLimitOffset = true;
        $(this.$refs.vGotop).fadeIn();
      } else if (this.overLimitOffset && window.pageYOffset == 0) {
        this.overLimitOffset = false;
        $(this.$refs.vGotop).fadeOut();
      }
    },
    goToTop() {
      $("html").animate({ scrollTop: 0 }, this.animationTime);
    }
  }
};
</script>
<style>
.o-gotoTop {
  display: none;
  position: fixed;
  z-index: 9998;
  border-radius: 50px;
  cursor: pointer;
}
.o-gotoTop img {
  background-repeat: no-repeat;
  background-size: contain;
  -webkit-background-size: contain;
}
</style>
